import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';

import CommentPost from 'flarum/forum/components/CommentPost';

/**
 * BHASVIC aren't using Flarum as forum software, so we should hide
 * the Reply button.
 *
 * At some point, we may wish to use it for logged-in users, though,
 * so let's only hide it for guests at the moment.
 */
export default function hideReplyButtonForGuests() {
  extend(CommentPost.prototype, 'actionItems', function (items) {
    // Always hide 'Reply' from guests
    if (!app.session.user && items.has('reply')) items.remove('reply');
  });
}
